import {CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useState} from 'react';

import WriteItem from './WriteItem';

const Item = ({value, onChange, onRemove, disabled, rules}) => {
  const [edit, setEdit] = useState(false);

  return (
    <div className="flex w-full pt-2">
      {
        edit ? (
          <WriteItem value={value} onChange={(newValue) => onChange(value, newValue)} icon={<CheckOutlined/>} rules={rules}/>
        ) : (
          <div className="w-full px-4 text-lg flex items-center"><div className="w-2 h-2 rounded-full bg-black opacity-50 mr-2"/>{value}</div>
        )
      }
      <div className="w-2"/>
      {
        edit ? (
          <Button disabled={disabled} icon={<CloseOutlined/>} onClick={() => setEdit(false)}/>
        ) : (<>
          <Button disabled={disabled} icon={<EditOutlined/>} onClick={() => setEdit(true)}/>
          <div className="w-2"/>
          <Button disabled={disabled} icon={<DeleteOutlined/>} onClick={() => onRemove(value)}/>
        </>)
      }
    </div>
  );
};

Item.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  disabled: PropTypes.bool,
  rules: PropTypes.array,
};

Item.defaultProps = {
  value: '',
  onChange: () => undefined,
  onRemove: () => undefined,
  icon: <PlusOutlined/>
};

export default memo(Item);
